import React from 'react';
import PropTypes from 'prop-types';
import DelayDiv from 'modules/common/components/DelayDiv';
import HistogramCard, {
  useHistogramCard,
} from 'partial/components/HistogramCard';
import {
  useSmsUsageGraph,
  usePushUsageGraph,
  useEmailUsageGraph,
} from '../hooks';

const skeleton = (
  <div
    className="bg-neutral-100 animate-pulse rounded-md"
    style={{ height: 361 }}
  />
);

const smsOptions = [
  {
    id: 'sms',
    label: 'SMS Usage',
    hook: useSmsUsageGraph,
    defaultChart: 'line',
    defaultMode: 'month',
  },
];

const pushOptions = [
  {
    id: 'push',
    label: 'Push Notification Usage',
    hook: usePushUsageGraph,
    defaultChart: 'line',
    defaultMode: 'month',
  },
];

const emailOptions = [
  {
    id: 'email',
    label: 'Email Usage',
    hook: useEmailUsageGraph,
    defaultChart: 'line',
    defaultMode: 'month',
  },
];

function DashboardCharts({ globalFilter }) {
  const smsHistogram = useHistogramCard(smsOptions);
  const pushHistogram = useHistogramCard(pushOptions);
  const emailHistogram = useHistogramCard(emailOptions);

  const chartFilter = globalFilter
    ? { from: globalFilter.from, to: globalFilter.to }
    : {};
  const filterKey = globalFilter?.key || 'default';

  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
      <DelayDiv delay={100} loader={skeleton}>
        <HistogramCard
          {...smsHistogram}
          dateRange
          filter={chartFilter}
          key={`sms-${filterKey}`}
        />
      </DelayDiv>
      <DelayDiv delay={100} loader={skeleton}>
        <HistogramCard
          {...pushHistogram}
          dateRange
          filter={chartFilter}
          key={`push-${filterKey}`}
        />
      </DelayDiv>
      <DelayDiv delay={100} loader={skeleton}>
        <HistogramCard
          {...emailHistogram}
          dateRange
          filter={chartFilter}
          key={`email-${filterKey}`}
        />
      </DelayDiv>
    </div>
  );
}

DashboardCharts.defaultProps = {
  globalFilter: null,
};

DashboardCharts.propTypes = {
  globalFilter: PropTypes.instanceOf(Object),
};

export default DashboardCharts;
